import { MessageCircle } from "lucide-react";
import { EVENTOS, track } from "@/lib/captacion";
import { Aparece } from "./Aparece";
import { COMO_EMPIEZAS, whatsappUrl } from "./content";

// Sin testimonios todavía, la objeción real es "¿cuánto me cuesta cambiarme?". Tres pasos, sin
// cards: una línea de tiempo se lee como un proceso, una grilla de cards como un catálogo.
export const ComoEmpiezas = () => (
  <section id="como-empiezas" className="scroll-mt-16 bg-slate-50" data-testid="landing-como-empiezas">
    <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6 lg:py-24">
      <Aparece className="max-w-2xl">
        <p className="text-xs font-semibold uppercase tracking-widest text-slate-400">Cómo empiezas</p>
        <h2 className="mt-3 font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
          Cambiarte no es un proyecto. <span className="text-slate-400">Te acompañamos en cada paso.</span>
        </h2>
      </Aparece>

      <ol className="relative mt-12 grid gap-10 md:grid-cols-3 md:gap-8">
        <div className="absolute left-5 top-5 hidden h-px w-[calc(100%-2.5rem)] bg-gradient-to-r from-indigo-200 via-indigo-200 to-transparent md:block" aria-hidden="true" />
        {COMO_EMPIEZAS.map((p, i) => (
          <Aparece as="li" key={p.titulo} delay={i * 0.06} className="relative">
            <span className="relative flex h-10 w-10 items-center justify-center rounded-full bg-indigo-600 font-display text-sm font-extrabold text-white ring-4 ring-slate-50">
              {i + 1}
            </span>
            <h3 className="mt-5 text-base font-bold text-slate-800">{p.titulo}</h3>
            <p className="mt-1.5 max-w-xs text-sm leading-relaxed text-slate-600">{p.texto}</p>
          </Aparece>
        ))}
      </ol>

      <Aparece className="mt-12 flex flex-col gap-3 rounded-2xl bg-white p-6 shadow-sm ring-1 ring-inset ring-slate-200/60 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-base font-bold text-slate-800">¿Prefieres conversarlo primero?</p>
          <p className="mt-1 text-sm text-slate-600">Escríbele al equipo SEBBIA por WhatsApp y resolvemos tus dudas.</p>
        </div>
        <a
          href={whatsappUrl()}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => track(EVENTOS.contacto, { canal: "whatsapp", seccion: "como-empiezas" })}
          className="inline-flex items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition-colors duration-200 hover:border-emerald-300 hover:bg-emerald-50/50 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-emerald-100"
          data-testid="como-empiezas-whatsapp"
        >
          <MessageCircle className="h-4 w-4 text-emerald-600" /> Escribir por WhatsApp
        </a>
      </Aparece>
    </div>
  </section>
);
